import { render, staticRenderFns } from "./CreateEmotionDialog.vue?vue&type=template&id=c16d5d60&scoped=true"
import script from "./CreateEmotionDialog.vue?vue&type=script&lang=js"
export * from "./CreateEmotionDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateEmotionDialog.vue?vue&type=style&index=0&id=c16d5d60&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16d5d60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c16d5d60')) {
      api.createRecord('c16d5d60', component.options)
    } else {
      api.reload('c16d5d60', component.options)
    }
    module.hot.accept("./CreateEmotionDialog.vue?vue&type=template&id=c16d5d60&scoped=true", function () {
      api.rerender('c16d5d60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/chat/emotion/dialog/CreateEmotionDialog.vue"
export default component.exports